import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { IGetAllServiceProps } from "@api/types/globalService.types";
import { getPartnerFrontendBootAPI } from "./partnerFrontend.api";
import { IPartnerFrontendBootResponseSchema } from "./partnerFrontend.types";

type IGetPartnerFrontendBootService = { partner: string } & Omit<
  IGetAllServiceProps,
  "page" | "per_page" | "stage_id" | "filters"
>;

const useGetPartnerFrontendBootService = ({
  partner,
  enableQuery = true,
  cacheKeys = [],
}: IGetPartnerFrontendBootService) => {
  return useQuery({
    queryKey: [...CACHE_KEYS.PARTNER_FRONTEND_BOOT, partner, ...cacheKeys],
    queryFn: (): Promise<{ data: IPartnerFrontendBootResponseSchema }> =>
      getPartnerFrontendBootAPI({ partner }),
    enabled: enableQuery,
  });
};

export { useGetPartnerFrontendBootService };
